import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./Mortandad.module.css";
import History from "../../components/history";
import { Button, Form, Table, Row, Col } from "react-bootstrap";
import { Icon, InlineIcon } from '@iconify/react';
import eyeFilled from '@iconify/icons-ant-design/eye-filled';
import editFilled from '@iconify/icons-ant-design/edit-filled';
import bxsTrash from '@iconify/icons-bx/bxs-trash';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { checkSession, isMobile } from "../../core/session";
import { displayDate } from "../../core/date";
import MortandadModal from "./MortandadModal";
import MortandadView from "./MortandadView";
import DeleteConfirmation from "./DeleteConfirmation";
import TimeFilter from "../../components/time-filter"
import CustomPagination from "../../components/pagination/CustomPagination";
import { formatAmount } from "../../core/amount";

const Mortandad = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(1);

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [showModal, setModalVisibility] = useState(false);
    const [showAsignations, setAsignationsVisibility] = useState(false);

    const [fechaDesde, setFechaDesde] = useState(undefined);
    const [fechaHasta, setFechaHasta] = useState(undefined);

    const [accounts, setAccounts] = useState([]);
    const [account, setAccount] = useState(undefined);

    const [showUserDetail, setUserDetailVisibility] = useState(false);
    const [showDelete, setDeleteVisibility] = useState(false);
    const [expense, setExpense] = useState(undefined);
    const [edit, setEdit] = useState(false);

    const [provider, setProvider] = useState(undefined);
    const [providers, setProviders] = useState([]);

    const [category, setCategory] = useState(0);
    const [categories, setCategories] = useState([]);
    const [carimbo, setCarimbo] = useState(0);
    const [probableCause, setProbableCause] = useState("");

    const [owners, setOwners] = useState([]);
    const [owner, setOwner] = useState(undefined);        

    const history = [
        {
            name: "Inicio",
            path: "/"
        },
        {
            name: "Movimientos de hacienda",
            path: "/movimientos"
        },
        {
            name: "Salidas",
            path: "/movimientos/salidas"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const callbackFiltroFechas = (fechaInicio, fechaFin) => {
        setFechaDesde(fechaInicio);
        setFechaHasta(fechaFin);
    }

    const handleSearch = (e) => {
        setPage(1);
        setPageSize(5);
        retrievePurchases();
    }

    const retrieveOwners = () => {
        let company = cookie.kUserSession.data["company"];
        axios.get(process.env.REACT_APP_API_URL + "owners?company_id=" + company.id , prepareHeaders())
        .then(rs => {
            if(rs.status == 200){
                let data = rs.data;
                setOwners(data);
            }
            else {
                setOwners([]);
            }
        })
        .catch(error => {
            console.error(error);
            setOwners([]);
        });
    }        

    const retrievePurchases = () => {
        setLoading(true);
        var currentFarm = cookie.kUserSession.data["farm"];
        var url = "movements/entrance/decease?page=" + page + "&page_size=" + pageSize + "&id_estancia=" + currentFarm.id;
        if (fechaDesde != undefined && fechaHasta != undefined) {
            url += "&start_date=" + fechaDesde + "&end_date=" + fechaHasta;
        }
        if(owner != undefined && owner.id != 0){
            url += "&id_propietario=" + owner.id;
        }        
        if(category != 0){
            url += "&id_categoria=" + category
        }
        if(carimbo != 0){
            url += "&carimbo=" + carimbo;
        }
        if(probableCause != ""){
            url += "&causa_probable=" + probableCause;
        }
        axios.get(process.env.REACT_APP_API_URL + url, prepareHeaders())
            .then(rs => {
                console.log(rs);
                if (rs.status == 206) {
                    let { content } = rs.data;
                    setLoading(false);
                    setTotalPages(rs.data.totalPages);
                    setPurchases(content);
                }
                else {
                    setLoading(false);
                    setTotalPages(1);
                    setPurchases([]);
                }
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
                setTotalPages(1);
                setPurchases([]);
            });
    }

    const retrieveProviders = () => {
        axios.get(process.env.REACT_APP_API_URL + "provider", prepareHeaders())
            .then(rs => {
                if (rs.status == 200) {
                    let { data } = rs.data;
                    setProviders(data);
                }
                else {
                    setProviders([]);
                    setProvider(undefined);
                }
            })
            .catch(error => {
                console.error(error);
                setProviders([]);
                setProvider(undefined);
            });
    }

    const isSupervisor = () => {
        if (cookie.kUserSession == undefined || cookie.kUserSession == null) {
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 1;
    }

    const isAdmin = () => {
        if (cookie.kUserSession == undefined || cookie.kUserSession == null) {
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 2;
    }

    const isInternalAdmin = () => {
        if (cookie.kUserSession == undefined || cookie.kUserSession == null) {
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 3;
    }

    const isClient = () => {
        if (cookie.kUserSession == undefined || cookie.kUserSession == null) {
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 4;
    }

    const openUserDetailView = (e, i) => {
        setExpense(i);
        setUserDetailVisibility(true);
    }

    const openUserEdit = (e, i) => {
        setExpense(i);
        setUserDetailVisibility(true);
        setEdit(true);
    }

    const handleDelete = (e, i) => {
        setExpense(i);
        setDeleteVisibility(true);
    }

    useEffect(() => {
        checkSession("purchases", props.history, cookie.kUserSession);
        retrievePurchases();
        retrieveCategories();
        retrieveProviders();
        retrieveOwners();
    }, []);

    useEffect(() => {
        retrievePurchases();
    }, [page, pageSize]);

    const toPage = (page) => {
        console.log("Setting page to ", page);
        setPage(page);
    };

    const retrieveCategories = () => {
        axios.get(process.env.REACT_APP_API_URL + "category", prepareHeaders())
            .then(rs => {
                if (rs.status == 200) {
                    let { data } = rs.data;
                    console.log(data)
                    setCategories(data);
                }
                else {
                    setCategories([]);
                    setCategory(undefined);
                }
            })
            .catch(error => {
                console.error(error);
                setCategories([]);
                setCategory(undefined);
            });
    };

    return (
        <>
            <DeleteConfirmation show={showDelete} handleClose={() => { setDeleteVisibility(false); }} data={expense} callback={retrievePurchases} />
            <MortandadView show={showUserDetail} edit={edit} handleClose={() => { setUserDetailVisibility(false); setEdit(false); }} data={expense} callback={retrievePurchases} />
            <MortandadModal show={showModal} handleClose={() => { setModalVisibility(false); }} callback={retrievePurchases} />
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Mortandad"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <section className={styles.side}>
                            <Form className={styles.searchForm}>
                                <TimeFilter callback={callbackFiltroFechas} />
                                <Row>
                                    <Col>
                                        <Form.Group style={{marginBottom: "15px"}}>
                                            <Form.Label className={styles.label}>Propietario</Form.Label>
                                            <Form.Control as="select" value={owner != undefined ? owner.id : undefined} className="karanda-input" onChange={(e) => {setOwner({...owner, id: e.target.value});}}>
                                                <option value={0}>      TODOS      </option>
                                                {
                                                    owners.map((i) => (
                                                        <option value={i.id}>{i.nombres + " " + i.apellidos}</option>
                                                    ))
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>                                        
                                <Row>
                                    <Col>
                                        <Form.Group style={{ marginBottom: "15px" }}>
                                            <Form.Label className={styles.label}>Categoria</Form.Label>
                                            <Form.Control as="select" value={category} className="karanda-input" onChange={(e) => setCategory(e.target.value)}>
                                                <option value={0}>      TODOS      </option>
                                                {
                                                    categories.map((i) => (
                                                        <option value={i.id_categoria}>{i.nombre}</option>
                                                    ))
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group style={{ marginBottom: "15px" }}>
                                            <Form.Label className={styles.label}>Carimbo</Form.Label>
                                            <Form.Control className="karanda-input" value={carimbo} onChange={(e) => setCarimbo(e.target.value)} type="number" placeholder="Ingrese carimbo" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group style={{ marginBottom: "15px" }}>
                                            <Form.Label className={styles.label}>Causa probable</Form.Label>
                                            <Form.Control className="karanda-input" value={probableCause} onChange={(e) => setProbableCause(e.target.value)} type="text" placeholder="Causa probable" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button className="karanda-btn" onClick={handleSearch}>Buscar</Button>
                                    </Col>
                                </Row>
                            </Form>                            
                        </section>
                    </Col>
                    <Col>
                        <section className={styles.content}>
                            <h1 className={styles.title}>Mortandad</h1>
                            <section className={styles.actions}>
                                {
                                    isSupervisor() || isAdmin() ? (
                                        <Button className={`karanda-btn ${styles.btnRegister}`} onClick={(e) => { setModalVisibility(true); }}>Registrar deceso</Button>
                                    ) : (<></>)
                                }
                                {
                                    loading ? <div style={{ marginTop: "15px", textAlign: "center" }}><img src={loadingBtn} height="50" /> </div> : (

                                        purchases.length == 0 ? (
                                            <div style={{ marginTop: "15px", textAlign: "center" }}><span>No hay resultados</span></div>
                                        ) 
                                        : 
                                        (
                                            isMobile() ? <span>Vista no disponible</span> :
                                            (
                                                <>
                                                    <Table className="karanda-table" style={{ marginTop: "15px" }}>
                                                        <thead>
                                                            <th >Fecha</th>
                                                            <th >Caravana N°</th>
                                                            <th >Categoría</th>
                                                            <th >Cantidad</th>
                                                            <th >CBO</th>
                                                            <th >Zona</th>
                                                            <th >Potrero</th>
                                                            <th >Causa probable</th>
                                                            <th >Observaciones</th>
                                                            <th >Acciones</th>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                purchases.map((i) => (
                                                                    <tr>
                                                                        <td >{displayDate(i.fecha_movimiento)}</td>
                                                                        <td >{i.nro_caravana}</td>
                                                                        <td >{i.categoria.nombre}</td>
                                                                        <td >{i.cantidad}</td>
                                                                        <td >{i.carimbo == 99 ? "" : i.carimbo}</td>
                                                                        <td >{i.retiro.nombre}</td>
                                                                        <td >{i.potrero}</td>
                                                                        <td >{i.causa_probable}</td>
                                                                        <td >{i.observacion}</td>
                                                                        <td >
                                                                            <Icon className={styles.icon} onClick={(e) => { openUserDetailView(e, i); }} icon={eyeFilled} height="15px" />&nbsp;&nbsp;

                                                                            {
                                                                                isSupervisor() ? (
                                                                                    <>
                                                                                        <Icon className={styles.icon} onClick={(e) => { openUserEdit(e, i); }} icon={editFilled} height="15px" />&nbsp;&nbsp;
                                                                                        <Icon className={styles.icon} onClick={(e) => { handleDelete(e, i); }} icon={bxsTrash} height="15px" />&nbsp;&nbsp;
                                                                                    </>
                                                                                ) : (<></>)
                                                                            }

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                    <CustomPagination page={page} pageSize={pageSize} changePageSize={setPageSize} toPage={toPage} totalPages={totalPages}/>
                                                </>
                                            )
                                        )
                                    )
                                }
                            </section>
                        </section>                    
                    </Col>
                </Row>



            </section>
        </>
    );

};

export default Mortandad;